import React, { Component } from 'react';
import { Text, View, Pressable, StyleSheet } from 'react-native';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { OPComponent, Utils, NavBar, Navigation, I18n } from '../components';

import { resetState, resetPassword } from './actions';
import { COLOR, FONT, FONT_SIZE, __WEB__ } from '../../constants/styles';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import CommonStyles from './common_styles';
import StyledInput from './styled_input';
import { ErrorView, AuthForm } from './auth_views';

const confirmPasswordInputRef = React.createRef();

class ResetPassword extends OPComponent {
  static navigatorStyle = NavBar.authNavbarStyle;
  static statusBarStyle = NavBar.authStatusBarStyle;
  static navigatorButtons = {
    leftButtons: [NavBar.buttons.cancel],
  };

  constructor(props) {
    super(props);

    this.state = {
      email: null,
      password: null,
      passwordHidden: true,
      confirmpassword: null,
      confirmPasswordHidden: true,
      validationErrorMessage: null,
      mfaToken: null,
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Navigation.registerForButtonEvents(this);

    Utils.trackScreen('Auth', 'Reset Password');
    // first clear any error/success messages from other auth forms
    // (such as forgot password form)
    this.props.actions.resetState({ statusOnly: true });
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  componentDidUpdate(prevProps) {
    if (
      !this.props.needsMFACode &&
      this.props.authStatus === SUCCESS &&
      prevProps.authStatus !== SUCCESS
    ) {
      this.goToLogin();
    }
  }

  goToLogin = () => {
    if (__WEB__) {
      Navigation.openScreen(
        {
          screen: 'Login',
          title: '',
          passProps: { military: this.state.military },
        },
        this.props.componentId
      );
    } else {
      Navigation.setStack(this.props.componentId, [
        {
          component: {
            name: 'Auth',
            options: {
              topBar: {
                visible: false,
              },
            },
          },
        },
        {
          component: {
            name: 'Login',
            options: {
              title: '',
              passProps: { military: this.state.military },
            },
          },
        },
      ]);
    }
  };

  handlePasswordChange = (password) => this.setState({ password });
  handlePasswordSubmit = () => confirmPasswordInputRef.current?.focus?.();
  handleSecureTextButtonPress = () => this.setState({ passwordHidden: !this.state.passwordHidden });
  handleConfirmPasswordChange = (confirmpassword) => this.setState({ confirmpassword });
  handleConfirmSecureTextButtonPress = () =>
    this.setState({ confirmPasswordHidden: !this.state.confirmPasswordHidden });
  handleCodeChange = (mfaToken) => this.setState({ mfaToken });

  errorMessage() {
    const submitError =
      this.props.authStatus === FAILED
        ? this.props.errorMessage?.message?.toString() || I18n.t('genericErrorMessage')
        : null;
    return this.state.validationErrorMessage || submitError;
  }

  submit = () => {
    if (!this.state.password) {
      this.setState({ validationErrorMessage: I18n.t('auth.enterPassword') });
      return;
    }
    if (!this.state.confirmpassword) {
      this.setState({ validationErrorMessage: I18n.t('auth.enterConfirmationPassword') });
      return;
    }
    if (this.state.password !== this.state.confirmpassword) {
      this.setState({ validationErrorMessage: I18n.t('auth.matchPasswords') });
      return;
    }
    if (this.state.validationErrorMessage) this.setState({ validationErrorMessage: null });

    Utils.trackEvent('Action', 'Tap', 'Request Password Reset');
    this.props.actions.resetPassword(
      this.props.token,
      this.state.password,
      this.state.mfaToken?.trim()
    );
  };

  renderReset() {
    const props = this.props;
    if (props.needsMFASetup) return null;
    if (props.needsMFACode) return null;

    return (
      <View style={styles.inputsContainer}>
        <ErrorView {...props} errorMessage={this.errorMessage()} />

        <StyledInput
          label={I18n.ac('auth.password')}
          value={this.state.password}
          secureTextEntry={!!this.state.passwordHidden}
          onChangeText={this.handlePasswordChange}
          onSubmitEditing={this.handlePasswordSubmit}
          onSecureTextButtonPress={this.handleSecureTextButtonPress}
          autoComplete={'password'}
          returnKeyType="next"
          testID="password"
        />

        <StyledInput
          ref={confirmPasswordInputRef}
          label={I18n.ac('auth.confirmPassword')}
          value={this.state.confirmpassword}
          secureTextEntry={!!this.state.confirmPasswordHidden}
          onChangeText={this.handleConfirmPasswordChange}
          onSubmitEditing={this.submit}
          onSecureTextButtonPress={this.handleConfirmSecureTextButtonPress}
          autoComplete={'password'}
          returnKeyType="go"
          testID="password"
        />

        <Pressable style={styles.button} onPress={this.submit}>
          <Text style={styles.buttonText}>{I18n.t('auth.updatePassword')}</Text>
        </Pressable>
      </View>
    );
  }

  render() {
    const props = this.props;
    return (
      <AuthForm
        {...props}
        errorMessage={this.errorMessage()}
        mfaToken={this.state.mfaToken}
        onSubmitMFA={this.submit}
        handleCodeChange={this.handleCodeChange}
        showActivityOverlay={props.authStatus === REQUESTING}
      >
        {this.renderReset()}
      </AuthForm>
    );
  }
}

const styles = StyleSheet.create({
  ...CommonStyles,
});

function mapStateToProps(state, ownProps) {
  // web has to parse this out of the URL search query
  let token = state.screens.auth.resetPasswordToken;
  if (__WEB__) {
    token = new URLSearchParams(location.search).get('token');
  }
  return {
    authStatus: state.screens.auth.status,
    errorMessage: state.screens.auth.errorMessage,
    needsMFASetup: state.screens.auth.needsMFASetup,
    needsMFACode: state.screens.auth.needsMFACode,
    token,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ resetState, resetPassword }, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
